// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Friends Component Styles */

.friends-container {
  position: relative;
}

/* Backdrop for mobile menus (Friends panel) */
.menu-backdrop {
  display: none;
}

.friends-toggle-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.friends-toggle-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.badge {
  background: #ff4757;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.badge.pending {
  background: #ffa502;
}

/* Friends Panel */
.friends-panel {
  position: fixed;
  right: 20px;
  top: 100px;
  width: 380px;
  max-height: 600px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 15000;
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease;
}

@media (max-width: 576px) {
  .menu-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(2, 6, 23, 0.55);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    z-index: 14000;
  }

  .friends-panel {
    left: 10px;
    right: 10px;
    top: 72px;
    width: auto;
    max-height: calc(100vh - 92px);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.friends-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #eee;
}

.friends-header h3 {
  margin: 0;
  color: #333;
  font-size: 16px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

/* Scrollable Content */
.friends-panel > div:not(.friends-header) {
  overflow-y: auto;
  padding: 12px;
  flex: 1 1;
}

.friends-panel > div:not(.friends-header)::-webkit-scrollbar {
  width: 6px;
}

.friends-panel > div:not(.friends-header)::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.friends-panel > div:not(.friends-header)::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

/* Sections */
.requests-section,
.sent-requests-section,
.friends-list-section {
  margin-bottom: 16px;
}

.requests-section h4,
.sent-requests-section h4,
.friends-list-section h4,
.add-friend-section h4 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.empty {
  color: #999;
  font-size: 13px;
  padding: 8px;
  text-align: center;
}

.loading {
  color: #999;
  font-size: 13px;
  padding: 8px;
  text-align: center;
}

/* Requests List */
.requests-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.request-item,
.sent-request-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #eee;
}

.request-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.request-info {
  flex: 1 1;
}

.request-info .username {
  margin: 0 0 4px 0;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.request-info .date {
  margin: 0;
  color: #999;
  font-size: 11px;
}

.request-actions {
  display: flex;
  gap: 8px;
}

.accept-btn,
.decline-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.accept-btn {
  background: #2ed573;
  color: white;
}

.accept-btn:hover {
  background: #26de81;
}

.decline-btn {
  background: #ff6348;
  color: white;
}

.decline-btn:hover {
  background: #ff5c3d;
}

/* Sent Requests */
.sent-request-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.sent-request-item .username {
  margin: 0;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.sent-request-item .status {
  margin: 0;
  color: #ffa502;
  font-size: 12px;
  font-weight: 600;
}

.sent-request-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sent-request-actions {
  display: flex;
  align-items: center;
}

.cancel-request-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: #f1f5f9;
  color: #475569;
  transition: all 0.2s ease;
}

.cancel-request-btn:hover {
  background: #e2e8f0;
  color: #334155;
}

/* Friends List */
.friends-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.friend-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.friend-info {
  flex: 1 1;
}

.friend-name-with-status {
  display: flex;
  align-items: center;
  gap: 6px;
}

.online-indicator {
  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.online-indicator.online {
  background-color: #2ecc71;
  border: 2px solid #27ae60;
  animation: pulse-online 2s infinite;
  box-shadow: 0 0 8px rgba(46, 204, 113, 0.8);
}

.online-indicator.offline {
  background-color: #e0e0e0;
  border: 2px solid #999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
}

@keyframes pulse-online {
  0%, 100% {
    opacity: 1;
    box-shadow: 0 0 6px rgba(46, 204, 113, 0.6);
  }
  50% {
    opacity: 0.6;
    box-shadow: 0 0 10px rgba(46, 204, 113, 0.8);
  }
}

.friend-info .username {
  margin: 0 0 4px 0;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.friend-info .stats {
  margin: 0;
  color: #999;
  font-size: 12px;
}

.friend-actions {
  display: flex;
  gap: 8px;
}

.challenge-btn,
.message-btn,
.remove-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.message-btn {
  background: #00b359;
  color: white;
}

.message-btn:hover {
  background: #009a48;
}

.challenge-btn {
  background: #667eea;
  color: white;
}

.challenge-btn:hover {
  background: #5568d3;
}

.remove-btn {
  background: #e8e8e8;
  color: #999;
}

.remove-btn:hover {
  background: #ddd;
  color: #666;
}

/* Add Friend Section */
.add-friend-section {
  border-top: 1px solid #eee;
  padding-top: 12px;
  margin-top: 12px;
}

.add-friend-btn {
  width: 100%;
  padding: 10px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-friend-btn:hover {
  background: #5568d3;
}

/* Search Form */
.search-user-form {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.search-user-form form {
  display: flex;
  gap: 8px;
}

.search-user-form input {
  flex: 1 1;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
}

.search-user-form input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.search-user-form button {
  padding: 8px 16px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.search-user-form button:hover {
  background: #5568d3;
}

/* Search Results */
.search-results {
  border: 1px solid #eee;
  border-radius: 6px;
  max-height: 200px;
  overflow-y: auto;
}

.search-result-item {
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search-result-item:last-child {
  border-bottom: none;
}

.search-result-item .username {
  margin: 0;
  font-weight: 600;
  color: #333;
  font-size: 13px;
}

.send-request-btn {
  padding: 6px 12px;
  background: #2ed573;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.send-request-btn:hover {
  background: #26de81;
}

.error {
  color: #ff4757;
  font-size: 12px;
  padding: 8px;
  text-align: center;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .friends-panel {
    position: fixed;
    right: 0;
    left: 0;
    top: auto;
    bottom: 0;
    width: 100%;
    max-height: 70vh;
    border-radius: 12px 12px 0 0;
  }

  .friends-toggle-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Friends.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;AACf;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,gCAAgC;IAChC,0BAA0B;IAC1B,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;IACX,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,aAAa;AACb;;;EAGE,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,YAAY;IACZ,4CAA4C;EAC9C;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,QAAQ;IACR,OAAO;IACP,SAAS;IACT,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Friends Component Styles */\n\n.friends-container {\n  position: relative;\n}\n\n/* Backdrop for mobile menus (Friends panel) */\n.menu-backdrop {\n  display: none;\n}\n\n.friends-toggle-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n}\n\n.friends-toggle-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.badge {\n  background: #ff4757;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.badge.pending {\n  background: #ffa502;\n}\n\n/* Friends Panel */\n.friends-panel {\n  position: fixed;\n  right: 20px;\n  top: 100px;\n  width: 380px;\n  max-height: 600px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  z-index: 15000;\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease;\n}\n\n@media (max-width: 576px) {\n  .menu-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(2, 6, 23, 0.55);\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px);\n    z-index: 14000;\n  }\n\n  .friends-panel {\n    left: 10px;\n    right: 10px;\n    top: 72px;\n    width: auto;\n    max-height: calc(100vh - 92px);\n  }\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.friends-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.friends-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  color: #999;\n}\n\n.close-btn:hover {\n  color: #333;\n}\n\n/* Scrollable Content */\n.friends-panel > div:not(.friends-header) {\n  overflow-y: auto;\n  padding: 12px;\n  flex: 1;\n}\n\n.friends-panel > div:not(.friends-header)::-webkit-scrollbar {\n  width: 6px;\n}\n\n.friends-panel > div:not(.friends-header)::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.friends-panel > div:not(.friends-header)::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 3px;\n}\n\n/* Sections */\n.requests-section,\n.sent-requests-section,\n.friends-list-section {\n  margin-bottom: 16px;\n}\n\n.requests-section h4,\n.sent-requests-section h4,\n.friends-list-section h4,\n.add-friend-section h4 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.empty {\n  color: #999;\n  font-size: 13px;\n  padding: 8px;\n  text-align: center;\n}\n\n.loading {\n  color: #999;\n  font-size: 13px;\n  padding: 8px;\n  text-align: center;\n}\n\n/* Requests List */\n.requests-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.request-item,\n.sent-request-item {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #eee;\n}\n\n.request-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.request-info {\n  flex: 1;\n}\n\n.request-info .username {\n  margin: 0 0 4px 0;\n  font-weight: 600;\n  color: #333;\n  font-size: 13px;\n}\n\n.request-info .date {\n  margin: 0;\n  color: #999;\n  font-size: 11px;\n}\n\n.request-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.accept-btn,\n.decline-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.accept-btn {\n  background: #2ed573;\n  color: white;\n}\n\n.accept-btn:hover {\n  background: #26de81;\n}\n\n.decline-btn {\n  background: #ff6348;\n  color: white;\n}\n\n.decline-btn:hover {\n  background: #ff5c3d;\n}\n\n/* Sent Requests */\n.sent-request-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.sent-request-item .username {\n  margin: 0;\n  font-weight: 600;\n  color: #333;\n  font-size: 13px;\n}\n\n.sent-request-item .status {\n  margin: 0;\n  color: #ffa502;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.sent-request-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.sent-request-actions {\n  display: flex;\n  align-items: center;\n}\n\n.cancel-request-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  background: #f1f5f9;\n  color: #475569;\n  transition: all 0.2s ease;\n}\n\n.cancel-request-btn:hover {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n/* Friends List */\n.friends-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.friend-item {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.friend-info {\n  flex: 1;\n}\n\n.friend-name-with-status {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.online-indicator {\n  width: 10px;\n  height: 10px;\n  min-width: 10px;\n  min-height: 10px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.online-indicator.online {\n  background-color: #2ecc71;\n  border: 2px solid #27ae60;\n  animation: pulse-online 2s infinite;\n  box-shadow: 0 0 8px rgba(46, 204, 113, 0.8);\n}\n\n.online-indicator.offline {\n  background-color: #e0e0e0;\n  border: 2px solid #999;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n@keyframes pulse-online {\n  0%, 100% {\n    opacity: 1;\n    box-shadow: 0 0 6px rgba(46, 204, 113, 0.6);\n  }\n  50% {\n    opacity: 0.6;\n    box-shadow: 0 0 10px rgba(46, 204, 113, 0.8);\n  }\n}\n\n.friend-info .username {\n  margin: 0 0 4px 0;\n  font-weight: 600;\n  color: #333;\n  font-size: 13px;\n}\n\n.friend-info .stats {\n  margin: 0;\n  color: #999;\n  font-size: 12px;\n}\n\n.friend-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.challenge-btn,\n.message-btn,\n.remove-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.message-btn {\n  background: #00b359;\n  color: white;\n}\n\n.message-btn:hover {\n  background: #009a48;\n}\n\n.challenge-btn {\n  background: #667eea;\n  color: white;\n}\n\n.challenge-btn:hover {\n  background: #5568d3;\n}\n\n.remove-btn {\n  background: #e8e8e8;\n  color: #999;\n}\n\n.remove-btn:hover {\n  background: #ddd;\n  color: #666;\n}\n\n/* Add Friend Section */\n.add-friend-section {\n  border-top: 1px solid #eee;\n  padding-top: 12px;\n  margin-top: 12px;\n}\n\n.add-friend-btn {\n  width: 100%;\n  padding: 10px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.add-friend-btn:hover {\n  background: #5568d3;\n}\n\n/* Search Form */\n.search-user-form {\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.search-user-form form {\n  display: flex;\n  gap: 8px;\n}\n\n.search-user-form input {\n  flex: 1;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.search-user-form input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.search-user-form button {\n  padding: 8px 16px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.search-user-form button:hover {\n  background: #5568d3;\n}\n\n/* Search Results */\n.search-results {\n  border: 1px solid #eee;\n  border-radius: 6px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.search-result-item {\n  padding: 10px 12px;\n  border-bottom: 1px solid #f0f0f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.search-result-item:last-child {\n  border-bottom: none;\n}\n\n.search-result-item .username {\n  margin: 0;\n  font-weight: 600;\n  color: #333;\n  font-size: 13px;\n}\n\n.send-request-btn {\n  padding: 6px 12px;\n  background: #2ed573;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.send-request-btn:hover {\n  background: #26de81;\n}\n\n.error {\n  color: #ff4757;\n  font-size: 12px;\n  padding: 8px;\n  text-align: center;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .friends-panel {\n    position: fixed;\n    right: 0;\n    left: 0;\n    top: auto;\n    bottom: 0;\n    width: 100%;\n    max-height: 70vh;\n    border-radius: 12px 12px 0 0;\n  }\n\n  .friends-toggle-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
